import { Children, cloneElement, useEffect, useRef, useState } from 'react';
import { razdvojiKoordinate, uOkviru } from '../lib/konstante';
import { procitajKoordinatu, provjeriKoordinate } from '../lib/evidencija';

/** Lokacija se mijenja samo izričitom potvrdom upisanih koordinata. */
export default function UnosKoordinata({
  lat,
  lng,
  onPotvrdi,
  onemoguceno,
  zauzeto = false,
  children,
}) {
  const [sirina, postaviSirinu] = useState('');
  const [duzina, postaviDuzinu] = useState('');
  const [poruka, postaviPoruku] = useState(null);
  const [radi, postaviRadi] = useState(false);
  const [potvrdjenOkvir, postaviPotvrdjenOkvir] = useState(false);
  const zakljucano = useRef(false);

  useEffect(() => {
    postaviSirinu(lat != null ? Number(lat).toFixed(6) : '');
    postaviDuzinu(lng != null ? Number(lng).toFixed(6) : '');
    postaviPotvrdjenOkvir(false);
  }, [lat, lng]);

  const naUnos = (vrijednost, postavi) => {
    const par = razdvojiKoordinate(vrijednost);
    if (par) {
      postaviSirinu(String(par[0]));
      postaviDuzinu(String(par[1]));
    } else postavi(vrijednost);
    postaviPoruku(null);
    postaviPotvrdjenOkvir(false);
  };
  const la = procitajKoordinatu(sirina);
  const ln = procitajKoordinatu(duzina);
  const izvanOkvira = la != null && ln != null && !uOkviru(la, ln);

  const spremi = async () => {
    if (zakljucano.current || zauzeto) return;
    let koordinate;
    try {
      koordinate = provjeriKoordinate(sirina, duzina);
    } catch (e) {
      postaviPoruku({ vrsta: 'greska', tekst: e.message });
      return;
    }
    if (izvanOkvira && !potvrdjenOkvir) {
      postaviPoruku({
        vrsta: 'upozorenje',
        tekst:
          'Pozicija je izvan područja vodovoda. Provjeri redoslijed i potvrdi koordinate prije spremanja.',
      });
      return;
    }
    zakljucano.current = true;
    postaviRadi(true);
    postaviPoruku(null);
    try {
      await onPotvrdi(...koordinate);
      postaviPoruku({
        vrsta: 'ok',
        tekst: 'Pozicija je spremljena i potvrđena.',
      });
    } catch (e) {
      postaviPoruku({ vrsta: 'greska', tekst: e.message });
    } finally {
      zakljucano.current = false;
      postaviRadi(false);
    }
  };

  if (onemoguceno) return null;
  const dodatni = Children.map(children, (dijete) =>
    dijete
      ? cloneElement(dijete, {
          disabled: radi || zauzeto || dijete.props.disabled,
        })
      : dijete,
  );
  return (
    <>
      <div className="unos">
        <h4>Lokacija priključka</h4>
        <div className="polja">
          <label>
            Geografska širina
            <input
              type="text"
              inputMode="decimal"
              autoComplete="off"
              value={sirina}
              placeholder="45.963791"
              disabled={radi || zauzeto}
              onChange={(e) => naUnos(e.target.value, postaviSirinu)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  spremi();
                }
              }}
            />
          </label>
          <label>
            Geografska dužina
            <input
              type="text"
              inputMode="decimal"
              autoComplete="off"
              value={duzina}
              placeholder="16.034846"
              disabled={radi || zauzeto}
              onChange={(e) => naUnos(e.target.value, postaviDuzinu)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  spremi();
                }
              }}
            />
          </label>
        </div>
        <p className="savjet">
          Obje koordinate možeš zalijepiti u jedno polje. Promjena vrijedi tek
          nakon potvrde.
        </p>
        {izvanOkvira && (
          <label className="potvrda-izvan">
            <input
              type="checkbox"
              checked={potvrdjenOkvir}
              disabled={radi || zauzeto}
              onChange={(e) => postaviPotvrdjenOkvir(e.target.checked)}
            />
            Potvrđujem da su koordinate izvan područja vodovoda ispravne.
          </label>
        )}
        {poruka && (
          <p
            className={`poruka ${poruka.vrsta}`}
            role={poruka.vrsta === 'greska' ? 'alert' : 'status'}
          >
            {poruka.tekst}
          </p>
        )}
      </div>
      <div className="gumbi">
        <button type="button" onClick={spremi} disabled={radi || zauzeto}>
          {radi ? 'Spremam…' : 'Potvrdi poziciju'}
        </button>
        {dodatni}
      </div>
    </>
  );
}
